const routes = [
  {
    path: "/manage/login",
    name: "manage-login",
    component: () =>
      import(/* webpackChunkName: "manage" */ "@/views/manage/Login.vue"),
    meta: {
      title: "登录",
      cache: true,
    },
  },
  {
    path: "/manage/list",
    name: "manage-list",
    component: () =>
      import(
        /* webpackChunkName: "manage" */ "@/views/manage/KepuyuanManage.vue"
      ),
    meta: {
      title: "科普员管理",
      cache: true,
    },
  },
  {
    path: "/manage/detail",
    name: "manage-detail",
    component: () =>
      import(
        /* webpackChunkName: "manage" */ "@/views/manage/ManageDetail.vue"
      ),
    meta: {
      title: "科普员详情",
      cache: true,
    },
  },
];
export default routes;
